module.exports = __webpack_public_path__ + "img/ic_parking.de8367c6.svg";